export default "__VITE_ASSET__BuwnM0Bc__"